import { Action, Reducer } from "redux";
import { TranslateState, TranslateTypes, TranslateActionTypes } from "./translateTypes";
import { KeyValue } from "@/main/models/common";
import {
	LASTSYNCTRANSLATIONS,
	TRANSLATIONS,
	getStorage,
	saveArrayStorage,
	saveStringStorage,
} from "@/main/services/storage";
import { composeTranslates } from "@/main/services/utils";

export const INITIAL_STATE: TranslateState = {
	translates: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
		cultureUserLogged: "",
		lastSyncTranslations: "",
	},
};

const translateReducer: Reducer<TranslateState> = (state: TranslateState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as TranslateActionTypes;
	switch (actionTypes.type) {
		case TranslateTypes.GET_TRANSLATES:
			return {
				...state,
				translates: {
					...state.translates,
					isLoading: true,
				},
			};
		case TranslateTypes.SAVE_TRANSLATES: {
			let dataTranslateApi: KeyValue[] = [];
			const dataTranslateStorage = getStorage(`${TRANSLATIONS}_${actionTypes.payload.cultureUserLogged}`);

			if (
				actionTypes.payload.data &&
				actionTypes.payload.data.translations &&
				actionTypes.payload.data.translations.length > 0
			) {
				dataTranslateApi = actionTypes.payload.data.translations;
				const idCultureUserLogged =
					actionTypes.payload.cultureUserLogged !== null ? actionTypes.payload.cultureUserLogged : "";

				if (dataTranslateApi !== null && dataTranslateApi.length > 0) {
					// Save last sync date
					saveStringStorage(
						`${LASTSYNCTRANSLATIONS}_${idCultureUserLogged}`,
						actionTypes.payload.data.lastSyncTranslations,
					);

					// Save translates
					const keyTranslateStorage = `${TRANSLATIONS}_${idCultureUserLogged}`;
					const translatationsStoraged: KeyValue[] | null = getStorage(keyTranslateStorage);

					let dataTranslatesToSaveStorage: KeyValue[] = [];
					if (translatationsStoraged && translatationsStoraged.length > 0) {
						const translatesUpdated: KeyValue[] = composeTranslates(idCultureUserLogged, dataTranslateApi);

						dataTranslatesToSaveStorage =
							translatesUpdated && translatesUpdated.length > 0 ? translatesUpdated : translatationsStoraged;
					} else {
						dataTranslatesToSaveStorage = dataTranslateApi;
					}

					// Save local storage
					saveArrayStorage(keyTranslateStorage, dataTranslatesToSaveStorage);

					// Save reducer
					return {
						...state,
						translates: {
							...state.translates,
							isLoading: false,
							errorMessages: actionTypes.payload.errorMessages,
							isError: actionTypes.payload.isError,
							data: dataTranslatesToSaveStorage,
							cultureUserLogged: actionTypes.payload.cultureUserLogged,
						},
					};
				}
			}

			return {
				...state,
				translates: {
					...state.translates,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: dataTranslateStorage,
					cultureUserLogged: actionTypes.payload.cultureUserLogged,
				},
			};
		}

		case TranslateTypes.RESET_REDUCER_TRANSLATES:
			return {
				...state,
				translates: INITIAL_STATE.translates,
			};
		default:
			return state;
	}
};

export default translateReducer;
